import { openComponentInPopup } from "./common";
import { PopupOptions, PopupWidth } from "./popup";

export default class CustomerDataFormLogin {
    private showLoginButton: HTMLInputElement;

    constructor(showLoginButtonId: string) {
        this.initElements(showLoginButtonId);
        this.subscribeShowLogin();
    }

    private initElements(showLoginButtonId: string): void {
        this.showLoginButton = <HTMLInputElement>document.getElementById(showLoginButtonId);
    }

    private subscribeShowLogin(): void {
        this.showLoginButton.addEventListener('click', async () => {
            await openComponentInPopup('LoginBox', null, <PopupOptions>{ width: PopupWidth.Mini }); 
        });
    }
}
